module.exports = __webpack_public_path__ + "img/unlocking.143e4d41.svg";